const Auth = {
    isAuthenticated(cb) {
        const token = localStorage.token;
        if (token && token !== "") {
            return true;
        } else {
            return false;
        }
    },
    getToken() {
        return localStorage.token;
    },
    getPayload() {
        const token = localStorage.token;
        if (!token) return null;
        try {
            const part = token.split('.')[1];
            if (!part) return null;
            const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
            const json = JSON.parse(atob(b64));
            return json;
        } catch (e) {
            return null;
        }
    },
    getRole() {
        const p = this.getPayload();
        return p && p.role != null ? p.role : null;
    },
    authenticate(token, cb) {
        localStorage.setItem("token", token);
        setTimeout(cb, 100); // fake async
    },
    signout(cb) {
        localStorage.removeItem("token");
        localStorage.removeItem("impersonation_admin_token");
        setTimeout(cb, 100);
    }
};
export default Auth;